import { Component } from '@angular/core';

@Component({
  selector: 'app-vendor-not-found',
  templateUrl: './vendor-not-found.component.html',
  styleUrl: './vendor-not-found.component.scss'
})
export class VendorNotFoundComponent {

}
